import styled from "styled-components";
import { FontSize } from "@themes/Fonts";
import Styles from "@themes/Styles";
import { lightTheme } from "@themes/Theme";

export const DateTimeInput = styled.input<{
    disabled?: boolean;
    focused?: boolean;
    widthPx?: number;
}>`
    position: relative;

    width: ${(props) => (props.widthPx ? `${props.widthPx}px` : `auto`)};

    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    border: 1px solid ${(props) => props.theme.borderPrimary};
    border-radius: ${Styles.borderRadiusSharp};
    padding: 4px;

    font: unset;
    font-size: ${FontSize.normal};

    color: ${(props) => props.theme.textColorPrimary} !important;
    background-color: ${(props) =>
        props.disabled ? props.theme.disabledColor : props.theme.backgroundPrimary} !important;

    color-scheme: ${(props) => (props.theme === lightTheme ? "light" : "dark")};

    &:focus {
        font-size: ${FontSize.normal};
    }

    ::-webkit-calendar-picker-indicator {
        display: none;
        -webkit-appearance: none;
    }
`;
